module.exports = __webpack_public_path__ + "img/30.f772f387.jpg";